<template>
  <div>
    <v-dialog
      v-model="show"
      width="90%"
      max-width="600"
      scrollable
    >
      <v-card>
        <v-card-title>
          Mailing about sick leave
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click.prevent="show = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="py-3">
          <v-data-table
            dense
            :headers="tableHeaders"
            :items="employeeForMailing"
            :items-per-page="-1"
            hide-default-footer
          >
            <template v-slot:[`item.Actions`]="{ item, index }">
              <v-btn icon small
                     color="primary"
                     @click.prevent="updateEmployeeFromMailing(item.employee_id, index)"
              >
                <v-icon>mdi-pencil-circle</v-icon>
              </v-btn>
              <v-btn icon small
                     color="red darken-2"
                     @click.prevent="showRemoveDialog(item.employee_id, index)"
              >
                <v-icon>mdi-delete-circle</v-icon>
              </v-btn>
            </template>
          </v-data-table>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn small color="success" @click="showAddEmployee = true">Add New</v-btn>
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      max-width="350px"
      max-height="350px"
      v-model="showAddEmployee"
      scrollable
      @click:outside="showAddEmployee = false; updateMode = false"
    >
      <v-card>
        <v-card-title>
          {{ updateMode ? 'Edit Employee' : 'New employee' }}
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click.prevent="showAddEmployee = false; updateMode = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-3">
          <v-row justify="center">
            <v-col cols="12" md="12" lg="12">
              <h3>Employee List</h3>
              <v-autocomplete
                v-model="newEmployeeId"
                :items="employeeList"
                item-text="full_name"
                item-value="employee_id"
                variant="underlined"
              >
              </v-autocomplete>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small color="primary" :disabled="!newEmployeeId" @click.prevent="addNewEmployeeToMailing">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ConfirmOrDeniedDialog
      v-if="removeDialog"
      v-model="removeDialog"
      :mode="confirmOrDeniedDialogModes.delete"
      @onDeleteClick="deleteEmployeeFromMailing"
      @onCancelClick="removeDialog = false"
      @onCloseClick="removeDialog = false"
    />
  </div>
</template>
<script>
import { getApiErrorMessage } from '@/utils/apiError'
export default {
  name: 'ApprovedSickLeaveMailing',
  components: {
    ConfirmOrDeniedDialog: () => import('@/components/global/ConfirmOrDeniedDialog.vue')
  },
  props: {
    value: {
      required: false
    }
  },
  data () {
    return {
      employeeForMailing: [],
      searchEmployee: '',
      newEmployeeId: null,
      employeeIdToDelete: null,
      employeeIndexToRemove: null,
      showAddEmployee: false,
      updateMode: false,
      removeDialog: false,
      tableHeaders: [
        {
          text: 'Full Name',
          value: 'full_name',
          divider: true,
          class: 'px-4 text-no-wrap'
        },
        {
          text: 'Email',
          value: 'email',
          divider: true,
          class: 'px-4 text-no-wrap'
        },
        {
          text: '',
          value: 'Actions',
          cellClass: 'px-2 text-no-wrap',
          class: 'px-2 text-no-wrap',
          width: '5%',
          sortable: false
        }
      ]
    }
  },
  mounted () {
    this.getEmployeeForMailing()
  },
  computed: {
    show: {
      get () {
        return this.value
      },
      set (value) {
        this.updateMode = false
        this.$emit('input', value)
      }
    },
    user () {
      return this.$store.getters.getUser
    },
    confirmOrDeniedDialogModes () {
      return this.$store.getters.getConfirmOrDeniedDialogModes
    },
    employeeList () {
      if (this.searchEmployee) {
        const reg = new RegExp(this.searchEmployee.toLowerCase(), 'gi')
        return this.$store.getters.getEmployee.filter(item => {
          reg.lastIndex = 0
          return reg.test(item.full_name.toLowerCase())
        })
      } else return this.$store.getters.getEmployee.filter(emp => !this.employeeForMailing.some(obj => emp.employee_id === obj.employee_id))
    }
  },
  methods: {
    getEmployeeForMailing () {
      this.axios.get('/api/requests/absence_sick_leave_email_notifications', {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        const employeeList = this.$store.getters.getEmployee
        const employeeForInform = res.data
        for (let i = 0; i < employeeList.length; i++) {
          for (let j = 0; j < employeeForInform.length; j++) {
            if (employeeList[i].employee_id === employeeForInform[j].employee_id) {
              this.employeeForMailing.push({ full_name: employeeList[i].full_name, email: employeeForInform[j].email, employee_id: employeeList[i].employee_id })
            }
          }
        }
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    addNewEmployeeToMailing () {
      this.axios.post(
        '/api/requests/absence_sick_leave_email_notifications',
        {
          employee_id: this.newEmployeeId
        },
        {
          headers: {
            Authorization: 'Bearer ' + this.user.token
          }
        }
      ).then((response) => {
        const addedEmployeeFromList = this.$store.getters.getEmployee.find(emp => emp.employee_id === this.newEmployeeId)
        response.data[0].full_name = addedEmployeeFromList.full_name
        this.employeeForMailing.push(...response.data)
        this.newEmployeeId = ''

        if (this.updateMode) {
          this.deleteEmployeeFromMailing()
        }

        this.showAddEmployee = false
      }).catch((error) => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    deleteEmployeeFromMailing () {
      this.axios.delete(`/api/requests/absence_sick_leave_email_notifications${this.employeeIdToDelete}`,
        {
          headers: {
            Authorization: 'Bearer ' + this.user.token
          }
        }
      ).then((response) => {
        this.employeeForMailing.splice(this.employeeIndexToRemove, 1)
        this.$store.dispatch('setSuccess', { successMsg: 'The employee has been successfully removed from the mailing list' })

        if (this.updateMode) {
          this.updateMode = false
        }
        this.removeDialog = false
      }).catch((error) => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    updateEmployeeFromMailing (id, index) {
      this.employeeIdToDelete = id
      this.employeeIndexToRemove = index
      this.showAddEmployee = true
      this.updateMode = true
    },
    showRemoveDialog (id, index) {
      this.employeeIdToDelete = id
      this.employeeIndexToRemove = index
      this.removeDialog = true
    }
  }
}
</script>
